<template>
	<div class="wrapper">
		<v-row>
			<v-col cols="12" tag="h1">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn to="/dashboard/" v-bind="attrs" v-on="on" icon>
							<v-icon>mdi-arrow-left</v-icon>
						</v-btn>
					</template>
					<span>Список проектов</span>
				</v-tooltip>
			{{ project.title }}
			</v-col>
		</v-row>

		<v-container class="fill-height height-minus-navbar" fluid>
			<EmptyProject v-if="projectTexts.length == 0" v-show="projectTexts.length == 0" />
			<Chart :data="chartData" v-if="chartData.length > 0" v-show="chartData.length > 0" />
			<TextManagement :data="projectTexts" :dummyData="dataIsDummy" :projectId="project.id" />
		</v-container>
	</div>
</template>

<script>
import EmptyProject from './EmptyProject'
import TextManagement from './Tabs/TextManagement'
import Chart from './Tabs/Chart'

import DATA from '../../fakeData'

export default {
	name:"ProjectItem",
	components: { EmptyProject, TextManagement, Chart },
	data: () => ({
		project:{ text:[] }, projectTexts:[], chartData:[], dataIsDummy:false
	}),
	created(){
		this.getProjectText(this.$route.params.projectId)
		this.$eventBus.$on('load_dummy_data', () => this.loadDummyData())
		this.$eventBus.$on('add_text', text => this.addText(text))
		this.$eventBus.$on('remove_text', textObj => this.removeText(textObj))
	},
	beforeDestroy(){
		this.$eventBus.$off('load_dummy_data')
		this.$eventBus.$off('add_text')
		this.$eventBus.$off('remove_text')
	},
	methods: {
		getProjectText(projectId){
			this.$api.get(`projects/${projectId}/?page=1`)
				.then(response => {
					this.project = response.data
					this.projectTexts = this.project.text
				})
				// TODO: Handle a 404 project not fround
				.catch(error => console.log('Error getting project details, ', error))
			
			this.$api.get(`projects/${projectId}/texts/all/`)
				.then(response => {
					this.chartData = response.data
				})
				.catch(error => console.log('Error getting chart data, ', error))
		},
		addText(text_string){
    		// PUT method is used for creating nested text objects
			this.$api.put(`projects/${this.project.id}/texts/`, {
				text:text_string,
				/* 
					...
					other fields retrieved from server
					...
				*/
			})
			.then(response => {
				this.project = response.data
				this.projectTexts = this.project.text
				this.$eventBus.$emit('text_added', true)
				this.dataIsDummy = false
			})
			.catch(error => {
				this.$eventBus.$emit('text_added', false)
				console.log('Error saving text, ', error)
			})
		},
		removeText(textObj){
    		// PATCH method is used for deleting nested text objects
			this.$api.patch(`projects/${this.project.id}/texts/`, {
				texts: textObj.map(obj => obj.id)
			})
			.then(response => {
				this.project = response.data
				this.projectTexts = this.project.text
				this.$eventBus.$emit('text_removed', true)
			})
			.catch(error => {
				this.$eventBus.$emit('text_removed', false)
				console.log('Error deleting text, ', error)
			})
		},
		loadDummyData(){
			this.$api.get(`projects/demo/?page=1`)
				.then(response => {
					this.projectTexts = response.data.results
				})
				// TODO: Handle a 404 project not fround
				.catch(error => console.log('Error getting project details, ', error))

			this.$api.get(`projects/demo/all/`)
				.then(response => {
					this.chartData = response.data
					this.$eventBus.$emit('loaded_dummy_data')
				})
				.catch(error => console.log('Error getting chart data, ', error))
			
			this.dataIsDummy = true
		}
	},
}
</script>